import Vue from "vue";
import vueFilters from "./vue-filters";
import {
    addVoucher,
    getCustomCart,
    removeItem,
    removeVoucher,
    setQuantity,
    updateCoupon,
} from "./request";
import { deepClone, updateCount } from "./helpers";

const processErrors = (dto) => {
    if (dto.error) {
        var err = dto.error;
        var errors = dto.cart.errors;

        console.error(err, errors);
    }
};

export default function init() {
    var el = document.getElementById("cart-app");
    if (!el) return;
    var token = el.getAttribute("data-token");

    var app = new Vue({
        el: el,
        delimiters: ["${", "}"],
        filters: vueFilters,
        data: {
            coupon: "",
            couponState: null,
            cart: null,
            cartErrors: null,
            loading: false,
        },
        mounted: async function () {
            this.loadCart(true);
        },
        computed: {
            // isValid: function() {
            //     return this.shippingMethod && this.country && this.totalPrice > 0;
            // }
        },
        methods: {
            loadCart: async function (showLoader) {
                if (showLoader) this.loading = true;
                let result = await getCustomCart();
                this.cart = result.data.cart;
                updateCount(this.cart);
                if (showLoader) this.loading = false;
            },
            onChangeQuantity: async function (line, event) {
                if (event.target.value == "") return;

                var qty = parseInt(event.target.value);
                await this.innerSetQuantity(line, qty);
            },
            innerSetQuantity: async function (line, count) {
                line.qty = count;

                if (line.qty > 0) {
                    this.cart.itemTotal = null;
                    this.cart.itemSubtotal = null;
                    this.cart = deepClone(this.cart);
                    await setQuantity(token, line.id, line.qty);
                    this.loadCart(false);
                } else {
                    this.removeItem(line);
                }
            },
            setQuantity: async function (line, count) {
                var qty = parseInt(line.qty) + count;

                await this.innerSetQuantity(line, qty);
            },
            removeItem: async function (item) {
                this.loading = true;
                let result = await removeItem(token, item);
                await this.loadCart(false);
                this.loading = false;
            },
            onAddCoupon: async function (e) {
                e.preventDefault();
                if (!this.coupon) return;
                this.cart.couponCode = this.coupon;
                this.cart.itemTotal = null;
                this.couponState = null;
                var result = await updateCoupon(token, this.coupon);

                if (result.data.error) {
                    processErrors(result.data);
                    this.cart.couponCode = null;
                    this.coupon = "";
                    this.couponState = "error";
                    // alert(result.data.cart.errors.couponCode);
                } else {
                    this.couponState = "success";
                    this.loadCart(false);
                }
            },
            onRemoveCoupon: async function (e) {
                e.preventDefault();
                this.cart.couponCode = null;
                this.coupon = "";
                this.couponState = "";
                this.cart.itemTotal = null;
                var result = await updateCoupon(token, "");
                if (result.data.error) {
                    this.couponState = "error";
                    processErrors(result.data);
                } else {
                    this.couponState = null;
                    this.loadCart(false);
                }
            },
            addVoucher: async function (e) {
                e.preventDefault();
                var result = await addVoucher(token, this.coupon);
                this.coupon = "";
                if (result.data.error) {
                    this.couponState = "error";
                } else {
                    this.couponState = "success";
                    this.loadCart(false);
                }
            },
            removeVoucher: async function (e, code) {
                e.preventDefault();
                var result = await removeVoucher(token, code);
                if (result.data.error) {
                    this.coupon = "";
                    this.couponState = "error";
                } else {
                    this.couponState = "success";
                    this.loadCart(false);
                }
            },
        },
        watch: {},
    });
}
